<template>
    <div class="upload-file">
      <p class="upload-file__title" :class="this.disabled ? 'disabled' : ''">{{ title }}</p>
      <p class="upload-file__tip">{{ tip }}</p>
      <label class="upload-file__btn" :disabled="disabled">
          {{ buttonText }}
          <input multiple type="file" :ref="name" :id="name" class="upload-file__input" :disabled="disabled" @change="fileUpload(name)">
      </label>
      <div :class="['upload-file__files', { scroll: withScroll }]" v-show="value.length > 0">
        <div :class="['upload-file__file', { file__scroll: withScroll }]" v-for="(item, index) in value" :key="item.name + index">
          <span class="upload-file__icon">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 0V5V5.5H12H17V18H0V0H11.5ZM12.5 0.5V4.5H16.5L12.5 0.5Z" fill="#E2D4D5"/>
            </svg>
          </span>
          <a :href="createURL(item)" target="_blank" class="upload-file__name" :title="item.name" :download="item.name">
            {{ sliceFileName(item.name) }}
          </a>
          <span class="upload-file__size" >
            {{(item.size / 1024/1024).toFixed(1)}} мб
          </span>
          <span v-show="!disabled" class="upload-file__delete" @click.stop="deleteFile(item, index)">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.62012 3.20703L3.2064 9.62075" stroke="#697178"/>
              <path d="M9.62012 9.62109L3.2064 3.20737" stroke="#697178"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'app-input-file',
  data () {
    return {
      files: [...this.value]
    }
  },
  props: {
    title: String,
    tip: String,
    disabled: Boolean,
    name: String,
    value: Array,
    buttonText: {
      type: String,
      default: 'Выберите файл'
    },
    withScroll: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fileUpload (name) {
      this.files = [...this.files, ...this.$refs[name].files]
      // console.log(this.value)
      this.$emit('value-changed', this.files)
    },
    createURL (file) {
      if (file.url) {
        return file.url
      }
      return URL.createObjectURL(file)
    },
    deleteFile (item, index) {
      this.$emit('delete-file', item) // saved delete id for request
      this.$delete(this.files, index)
      this.$emit('value-changed', this.files)
    },
    sliceFileName (fileName) {
      return fileName.length < 30 ? fileName : `${fileName.slice(0, 30)}...`
    }
  },
  mounted () {
  },
  watch: {
    value (val) {
      this.files = [...val]
    }
  }
}
</script>

<style lang="scss" scoped>
  .upload-file {
    &__files {
      display: flex;
      margin-top: 20px;
      flex-wrap: wrap;
      max-width: 750px;

      &.scroll {
        overflow: auto;
        max-height: 144px;

        &::-webkit-scrollbar {
          width: 7px;
        }

        &::-webkit-scrollbar-track {
          background-color: $color_third;
        }

        &::-webkit-scrollbar-thumb {
          background-color: $color_second-light;
        }
      }
    }

    &__file {
      display: flex;

      &.file__scroll {
        margin-bottom: 12px;
      }

      &:not(.file__scroll)  {
        margin-bottom: 10px;
        margin-right: 22px;
        width: 47%;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &__delete {
      cursor: pointer;
    }

    &__icon {
      margin-right: 8px;
    }

    &__size {
      color: #cbcbcb;
      font-size: 16px;
      line-height: 24px;
      margin-left: 2px;
      margin-right: 3px;
    }

    &__name {
      font-size: 16px;
      line-height: 24px;
      color: $font_color_second;
    }
    &__title {
        color: $font_color_second;
        margin-bottom: 10px;

      &.disabled {
        color: #c4c4c4;
      }
    }

    &__tip {
        color: $font_color_second;
        font-size: 14px;
        margin-bottom: 10px;
    }

    &__btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 160px;
        height: 40px;
        color: $color__orange;
        font-weight: bold;
        border: 1px solid $color__orange;
        border-radius: 3px;
        padding: 10px 15px 10px 15px;
        transition: .3s;
        cursor: pointer;
        user-select: none;

        &:hover {
            border-color: $color__copper-pink;
            color: $color__white;
            background: $color__copper-pink;
        }

        &[disabled] {
            pointer-events: none;
            cursor: auto;
            border: 1px solid $color_deactive;
            color: $color_deactive;
        }
    }

    &__input {
        display: none;
    }
  }
</style>
